import Index from './Index.vue';

export default {
  path: 'faturamentos',
  name: 'config-faturamento',
  component: Index,
};
